import { makeStyles } from '@material-ui/core'

export default makeStyles({
  fieldContainer: {
    marginBottom: 20,
  },
})
